import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var TabStop = /** @class */ (function (_super) {
    __extends(TabStop, _super);
    function TabStop(alignment, position, decimalAlignmentToken) {
        if (alignment === void 0) { alignment = 'start'; }
        if (position === void 0) { position = 0; }
        if (decimalAlignmentToken === void 0) { decimalAlignmentToken = ''; }
        var _this = this;
        alignment = axCoerceString(alignment);
        position = +position;
        decimalAlignmentToken = axCoerceString(decimalAlignmentToken);
        _this = _super.call(this) || this;
        console.warn('[TabStop] not implemented');
        return _this;
    }
    Object.defineProperty(TabStop.prototype, "alignment", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _alignment: string;
        // _position: number;
        // _decimalAlignmentToken: string;
        get: function () {
            console.warn('[TabStop] - get alignment not implemented');
            return;
        },
        set: function (value) {
            value = axCoerceString(value);
            console.warn('[TabStop] - set alignment not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabStop.prototype, "position", {
        get: function () {
            console.warn('[TabStop] - get position not implemented');
            return;
        },
        set: function (value) {
            value = +value;
            console.warn('[TabStop] - set position not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabStop.prototype, "decimalAlignmentToken", {
        get: function () {
            console.warn('[TabStop] - get decimalAlignmentToken not implemented');
            return;
        },
        set: function (value) {
            value = axCoerceString(value);
            console.warn('[TabStop] - set decimalAlignmentToken not implemented');
        },
        enumerable: true,
        configurable: true
    });
    TabStop.forceNativeConstructor = true;
    TabStop.forceNativeMethods = true;
    return TabStop;
}(ASObject));
export { TabStop };
